module.exports = __webpack_public_path__ + "static/media/pyomo.9e49b6d6.jpg";